import { commitMutation,
  graphql } from 'react-relay';
import environment from '../.';
import { basicMutationOnCompleted, onErrorMutation } from './common/common';

const mutation = graphql`
mutation SignUpMutation($email: String!, $password: String!, $extra: UserExtraInput!, $token: String!) {
  signUp(email: $email, password: $password, extra: $extra, token: $token) { 
    ok
    error
  }
}
`;

export default ({ email, password, extra, token }, done) => {
  const variables = {
    email,
    password,
    extra,
    token
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ signUp }) => basicMutationOnCompleted(signUp, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
